import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageTemplateProps {
  data: {
    page: {
      databaseId?: number
      path?: string
      title?: string
      seo: any
      flexContent: any
      // locale: any
      translations: any
    }
  }
  location?: any
  prefix?: string
}

const PageTemplate: React.FC<PageTemplateProps> = ({
  data: {
    page: { databaseId, flexContent, seo, translations },
  },
  location = {},
  prefix = 'post_Flexcontent',
}) => (
  <Layout
    pageId={databaseId}
    // locale={locale.locale || 'nl_NL'}
    translations={translations}
  >
    <SEO seo={seo} />
    <FlexContentHandler
      prefix={prefix}
      fields={flexContent}
      location={location}
    />
  </Layout>
)

export const pageQuery = graphql`
  query postById($pageId: String!) {
    page: wpPost(id: { eq: $pageId }) {
      ...generalPostFragment
    }
  }
`

export default PageTemplate
